// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"458":"15bd5806","764":"72dc22fc"}[chunkId] + ".css";
};